import React, { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

import TextLink from '../UI/TextLink/TextLink';
import RichText from '../UI/RichText';
import BladeContainer from '../UI/BladeContainer/BladeContainer';
import {
  Card,
  CardContent,
  Title,
  Description,
  Icon,
  TextWrapper,
} from './styles';

interface Props {
  locale?: string;
  cardData?: Record<string, any>;
  bladeData?: Record<string, any>;
  backgroundImageData?: Record<string, any>;
  section?: string;
}

const CallToActionCard = ({
  locale,
  cardData,
  bladeData,
  backgroundImageData,
  section,
}: Props) => {
  // Blade rich text options
  const bladeOptions = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <p>{children}</p>,
      [BLOCKS.HEADING_1]: (_, children) => <h2>{children}</h2>,
      [BLOCKS.HEADING_2]: (_, children) => <h2>{children}</h2>,
      [BLOCKS.HEADING_3]: (_, children) => <h3>{children}</h3>,
      [BLOCKS.EMBEDDED_ENTRY]: (node) => (
        <TextLink
          route={node.data.target.ctaTarget}
          url={node.data.target.ctaUrl}
          linkText={node.data.target.ctaLabel.ctaLabel}
          locale={locale}
          data-section={section}
          data-cta-id={`${ReactHtmlParser(cardData?.cardHeading)} - ${
            node.data.target.ctaLabel.ctaLabel
          }`}
        />
      ),
      [INLINES.EMBEDDED_ENTRY]: (node) => (
        <TextLink
          route={node.data.target.ctaTarget}
          url={node.data.target.ctaUrl}
          linkText={node.data.target.ctaLabel.ctaLabel}
          locale={locale}
          data-section={section}
          data-cta-id={`${ReactHtmlParser(cardData?.cardHeading)} - ${
            node.data.target.ctaLabel.ctaLabel
          }`}
        />
      ),
    },
  };

  // Cards each trigger a blade
  const [ctaBladeVisible, setCtaBladeVisible] = useState(false);

  return (
    <>
      {/* Card */}
      <Card
        desktopImage={
          backgroundImageData?.backgroundImageDesktop?.asset?.localImage
            ?.publicURL
        }
      >
        <div className="wrapper">
          <Icon image={cardData?.cardIcon} isImageDecorative />
          <TextWrapper>
            <Title data-testid="call-to-action-title">
              {ReactHtmlParser(cardData?.cardHeading)}
            </Title>
            <Description data-testid="call-to-action-description">
              {ReactHtmlParser(cardData?.cardDescription?.cardDescription)}
            </Description>
          </TextWrapper>
          <TextLink
            className="functionalTextLink"
            linkText={cardData?.cardCta?.ctaLabel?.ctaLabel}
            route={cardData?.cardCta?.ctaTarget}
            locale={locale}
            data-testid="call-to-action-show-blade"
            data-section={section}
            data-cta-id={`${ReactHtmlParser(cardData?.cardHeading)} - ${cardData
              ?.cardCta?.ctaLabel?.ctaLabel}`}
            onClick={(e) => {
              e.preventDefault();
              setCtaBladeVisible(!ctaBladeVisible);
            }}
          />
        </div>
      </Card>

      {/* Blade opened by card */}
      <BladeContainer
        bladeState={ctaBladeVisible}
        setBladeState={setCtaBladeVisible}
        addDivider
        bladeWidth={767}
        locale={locale}
      >
        <CardContent>
          <Icon
            image={bladeData?.bladeSections && bladeData?.bladeSections[0]}
          />
          <RichText
            document={
              bladeData?.bladeSections && bladeData?.bladeSections[1]?.heading
            }
            options={bladeOptions}
          />
          <RichText
            document={
              bladeData?.bladeSections
              && bladeData?.bladeSections[1]?.contentBody
            }
            options={bladeOptions}
          />
        </CardContent>
      </BladeContainer>
    </>
  );
};
export default CallToActionCard;
